import React, { useEffect, useMemo, useState } from 'react';
import { Button, Drawer, Form, Input, message, Select } from 'antd';
import { EDIT_ERROR, REQUEST_LOADING, SUCCESS_UPDATE } from 'constants/alerts';
import { PartnerAccountsService } from 'services/PartnerAccountsService';
import { requiredRule } from 'utils/forms/validationRules';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

const type = [
  { text: 'Партнер', value: 'partner' },
  { text: 'Комиссия', value: 'commission' },
];

const is_active = [
  { text: 'Да', value: true },
  { text: 'Нет', value: false },
];

function PartnerAccountsForm({
  isActive,
  admins,
  initialValues,
  onClose,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [typeIs, setTypeIs] = useState('partner');

  const partners = useMemo(() => {
    return admins.map((item) => {
      return {
        text: {
          company_name: item.full_name,
          partner_name: item.user.full_name,
        },
        value: item.id,
      };
    });
  }, [admins]);

  useEffect(() => {
    if (initialValues) {
      const { bcc_account, is_active, type, admin } = initialValues;

      setTypeIs(type);

      form.setFieldsValue({
        admin,
        bcc_account,
        is_active,
        type,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    delete values.bcc_account;

    if (!values.admin) {
      values.admin = null;
    }

    handleUpdate(values, initialValues.id);
  };

  const handleUpdate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isUpdated = await PartnerAccountsService.editPartnerAccounts(
        data,
        id
      );

      if (isUpdated) {
        onClose();
        onSuccess();
        form.resetFields();
        message.success(SUCCESS_UPDATE);
      }
    } catch (err) {
      message.error(EDIT_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <Drawer
      title="Редактирование cчета партнеров"
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        <Form.Item name="bcc_account" label="Номер счета в БЦК">
          <Input readOnly placeholder="Номер счета в БЦК" />
        </Form.Item>

        <Form.Item name="type" label="Тип">
          <Select placeholder="Тип" onChange={setTypeIs}>
            {type.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {typeIs === 'partner' && (
          <Form.Item name="admin" label="Партнер" rules={[requiredRule]}>
            <Select placeholder="Партнер">
              {partners.map(({ value, text }) => (
                <Select.Option key={value} value={value}>
                  {text.partner_name}
                  {text.company_name && ` - ${text.company_name}`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item name="is_active" label="Активный">
          <Select placeholder="Активный">
            {is_active.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            Редактировать
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { PartnerAccountsForm };
